/**
 * Gobodo RBAC authorization helpers (Abilities API).
 */

import { AbilitiesApi } from '@gobodo/gobodo-api-promise';
import GobodoConfig from '../../config/gobodoConfig';
import { getGobodoClient } from '../../gobodo/gobodoClient';

export const CATEGORY_ADMIN_PERMISSION = 'CATEGORY_ADMIN';

function parseOptionalCategoryAdminObjectId(): number | null {
  const raw =
    process.env.GOBODO_CATEGORY_ADMIN_OBJECT_ID ||
    process.env.REACT_APP_GOBODO_CATEGORY_ADMIN_OBJECT_ID ||
    process.env.NEXT_PUBLIC_GOBODO_CATEGORY_ADMIN_OBJECT_ID;
  if (raw == null || String(raw).trim() === '') return null;
  const n = parseInt(String(raw), 10);
  return Number.isFinite(n) ? n : null;
}

/**
 * Graph object id used for AbilitiesApi.checkAuthorization CATEGORY_ADMIN.
 * Override with REACT_APP_GOBODO_CATEGORY_ADMIN_OBJECT_ID when the default graph id is wrong for a tenant.
 */
export function getCategoryAdminCheckObjectId(): number {
  const override = parseOptionalCategoryAdminObjectId();
  if (override != null) return override;
  return GobodoConfig.graph();
}

export function authorizationCheckResponseAuthorized(data: unknown): boolean {
  if (data == null) return false;
  const d = data as { getAuthorized?: () => boolean; authorized?: boolean };
  if (typeof d.getAuthorized === 'function') return Boolean(d.getAuthorized());
  if (typeof d.authorized === 'boolean') return d.authorized;
  return false;
}

/**
 * Returns whether the current user has CATEGORY_ADMIN on the configured object id.
 */
export async function fetchCategoryAdminAccess(): Promise<boolean> {
  try {
    const client = getGobodoClient();
    const api = new AbilitiesApi(client);
    const objectId = getCategoryAdminCheckObjectId();
    const res = await api.checkAuthorization(objectId, CATEGORY_ADMIN_PERMISSION, {
      cacheduration: '60',
    });
    return authorizationCheckResponseAuthorized(res);
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[gobodoAuthorizationService] CATEGORY_ADMIN check failed:', e);
    }
    return false;
  }
}
